import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

const GameDetailsModal = ({
  isViewDetailsOpen,
  closeDetailsModal,
  selectedGameId,
}) => {
  const [game, setGame] = useState(null);
  const { games } = useSelector((state) => state.games);

  useEffect(() => {
    const selectedGame = games?.find((game) => game?.gameId == selectedGameId);
    setGame(selectedGame);
  }, [selectedGameId]);

  return (
    <Modal
      show={isViewDetailsOpen}
      onHide={isViewDetailsOpen}
      centered
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">Game Details</h5>
        <button
          type="button"
          className="btn-close"
          onClick={closeDetailsModal}
        ></button>
      </div>
      <div className="modal-body">
        <table className="table table-borderless">
          <tbody>
            <tr>
              <td>
                <span className="fw-semibold">Game Name: </span>
                <span>{game?.gameName}</span>
              </td>
              <td>
                <span className="fw-semibold">Sport: </span>
                <span>{game?.sportName}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Court: </span>
                <span>{game?.courtName}</span>
              </td>
              <td>
                <span className="fw-semibold">Host Name: </span>
                <span>{game?.hostName}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Singularity: </span>
                <span>{game?.singularity}</span>
              </td>
              <td>
                <span className="fw-semibold">City: </span>
                <span>{game?.city}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Status: </span>
                <span>{game?.status}</span>
              </td>
              <td>
                <span className="fw-semibold">Paid: </span>
                <span>{game?.paid == true ? "Yes" : "No"}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Start Time: </span>
                <span>{game?.startTime}</span>
              </td>
              <td>
                <span className="fw-semibold">End Time: </span>
                <span>{game?.endTime}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Minor: </span>
                <span>{game?.minor == true ? "Yes" : "No"}</span>
              </td>
              <td>
                <span className="fw-semibold">Court Price: </span>
                <span>{game?.courtPrice}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Game Details: </span>
                <span>{game?.details}</span>
              </td>
              <td>
                <span className="fw-semibold">Participants: </span>
                <span>
                  {game?.participants?.map(
                    (player, index) =>
                      `${player?.name}[${player?.userId}]${
                        index + 1 == game?.participants?.length ? "" : ", "
                      }`
                  )}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default GameDetailsModal;
